var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolderPink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.41863 1.75002C9.23325 1.74142 9.99363 2.11767 10.4924 2.75642L11.2624 3.78017C11.5074 4.08642 11.8749 4.27017 12.2686 4.27017H14.9549C18.1836 4.27017 19.7586 5.99392 19.7499 9.52892V13.7902C19.7499 17.1677 17.6674 19.2502 14.2811 19.2502H7.70988C4.34113 19.2502 2.24988 17.1677 2.24988 13.7814V7.21017C2.24988 3.58767 3.85988 1.75002 7.03613 1.75002H8.41863ZM15.0511 12.0664H6.94863C6.58113 12.0664 6.29238 12.3552 6.29238 12.7227C6.29238 13.0814 6.58113 13.3789 6.94863 13.3789H15.0511C15.4099 13.3789 15.6986 13.0814 15.6986 12.7227C15.6986 12.3552 15.4099 12.0664 15.0511 12.0664Z",
    fill: "#D20E50"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderPink);
export default __webpack_public_path__ + "static/media/FolderPink.99470ef8.svg";
export { ForwardRef as ReactComponent };